import React, {Component} from 'react';
import CallToAction from '../../components/CallToAction/CallToAction';
import Aux from '../../hoc/Aux/Aux';
import CampaignFlow from '../../assets/images/icon-campaign-flow.svg';
import CallToActionPlaceholder from "../../components/UI/Placeholder/CallToActionPlaceholder/CallToActionPlaceholder";
import {cleanLocationProp} from "../../shared/utility";
import {Row, Col} from 'reactstrap';
import axios from '../../axios-base';

class home extends Component {
    constructor(props){
        super(props);
        this.state = {
            ctas: null
        };
    };

    componentDidMount = () => {
        axios.get('/cta/', {
            params: {
                page: cleanLocationProp(this.props.location.pathname)
            }})
        .then(response => {
            this.setState({ctas: response.data});
        })
        .catch(error => {
            this.setState({error: true});
        });
    };

    render() {
        let cta = (
            <React.Fragment>
                <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
                <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
                <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
                <Col sm="6" className="my-3 d-flex align-items-start flex-column"><CallToActionPlaceholder/></Col>
            </React.Fragment>
        );
        if (this.state.ctas){
            cta = this.state.ctas.map((cta, key)=> (
                <React.Fragment key={key} >
                    {key === 2 ?
                        <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                            <img className="img-fluid" src={CampaignFlow} alt="Wettbewerbsablauf"/>
                        </Col>
                    : null}
                    <Col sm="6" className="my-3 d-flex align-items-start flex-column">
                        <CallToAction
                            headline={cta.headline}
                            copy={cta.copy}
                            buttonText={cta.buttonText}
                            buttonColor={cta.buttonColor}
                            linkUrl={cta.linkUrl}
                            outline={cta.outline}
                        />
                    </Col>
                </ React.Fragment>
            ));
        }

        return (
            <Aux>
                <Row>
                    {cta}
                </Row>
            </Aux>
        );
    }
}

export default home;



// WEBPACK FOOTER //
// ./src/containers/Home/Home.js